import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Logout from "./pages/Logout";
import EmailVerification from "./pages/EmailVerification";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/logout/:token" element={<Logout />} />
          <Route
            path="/email-verification/:key"
            element={<EmailVerification />}
          />
          {/* <Route path="expenses" element={<Expenses />} />*/}
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
